import React, { Fragment, useState, useEffect } from 'react'
import { Button, Col, Modal, ModalBody, ModalHeader, Row, Table } from 'reactstrap';
import { ExportInvoiceDefaultValues } from '../../data/const';
import { PaginationComponent } from '../Pagination/PaginationComponent';
import { GetInvoiceId } from '../../services/invoice/invoice';
import { useSweetAlert } from '../../hooks/sweetAlerts/useSweetAlert';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";


export const ModalInvoiceRelateds = (props) => {
    const {
        modalTitle, modalListEgress,
        listNims,
        toggleModalListEgress,
        handleSelectInvoice,
        setPage, page, limit, setLimit, totalPages, totalRecords
    } = props;


    const [createSweet] = useSweetAlert();

    const [globalFilter, setGlobalFilter] = useState("");




    const selectInvoice = async (invoice) => {
        if (invoice?.id_invoice) {
            const dataInvoice = await GetInvoiceId(invoice?.id_invoice, true);

            console.log(dataInvoice);

            if (dataInvoice.code === 200) {
                handleSelectInvoice([dataInvoice?.data]);
                toggleModalListEgress();
            }
            else
                createSweet("warning", "warning", "Facturas", "No fue posible encontrar la información de la factura");
        }
    }

    return (
        <Dialog
            visible={modalListEgress}
            onHide={toggleModalListEgress}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-file-pdf-o"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Cfdi relacionados
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-large`}
            footer={
                <>
                    <Button
                        color="danger text-center"
                        type="button"
                        onClick={toggleModalListEgress}
                    >
                        Cancelar
                    </Button>

                </>
            }
        >

            <Col sm="12" className='pt-3' >
                <DataTable

                    className="data-table"
                    value={listNims}
                    lazy
                    paginator
                    first={(page - 1) * limit}
                    rows={limit}
                    totalRecords={totalRecords}
                    rowsPerPageOptions={[8, 20, 30, 40, 50]}
                    onPage={(event) => {
                        const newLimit = event.rows;
                        const newPage = Math.floor(event.first / newLimit) + 1;

                        setLimit(newLimit);
                        setPage(newPage);
                    }}
                    globalFilter={globalFilter}
                    emptyMessage={
                        <div className="text-center">
                            <img
                                src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                style={{ width: "20%" }}
                                alt="Sin resultados"
                            />
                            <br />
                            <p
                                className="badge badge-light-primary mt-2"
                                style={{ fontSize: "10px" }}
                            >
                                No se encontraron facturas de egreso.
                            </p>
                        </div>
                    }

                >
                    <Column
                        header="Acciones"
                        body={(rowData) => (
                            <Button
                                color="secondary text-center"
                                type="button"
                                onClick={() => selectInvoice(rowData)}
                                size='xs'
                            >
                                Seleccionar
                            </Button>

                        )}
                        headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "7px 5px",
                            textAlign: "center",
                        }}
                        bodyStyle={{
                            textAlign: "center",
                            fontSize: "10px",
                            padding: "6px",
                        }}
                        style={{ width: "12%" }}
                    />

                    <Column
                        field="folio"
                        header={ExportInvoiceDefaultValues.tableHeaderEgress.thFolio}

                        headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "7px 5px",
                        }}
                        bodyStyle={{
                            textAlign: "center",
                            fontSize: "10px",
                            padding: "6px",
                        }}
                        style={{ width: "12%" }}
                    />

                    <Column
                        field="date"
                        header={ExportInvoiceDefaultValues.tableHeaderEgress.thDate}

                        headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "7px 5px",
                        }}
                        bodyStyle={{
                            textAlign: "center",
                            fontSize: "10px",
                            padding: "6px",
                            whiteSpace: "nowrap",
                        }}
                        style={{ width: "14%" }}
                    />

                    <Column
                        field="code_pay_method"
                        header={ExportInvoiceDefaultValues.tableHeaderEgress.thPayMethod}

                        headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "7px 5px",
                        }}
                        bodyStyle={{
                            textAlign: "center",
                            fontSize: "10px",
                            padding: "6px",
                        }}
                        style={{ width: "15%" }}
                    />

                    <Column
                        field="total"
                        header={ExportInvoiceDefaultValues.tableHeaderEgress.thTotal}

                        body={(rowData) =>
                            Number(rowData.total || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                        }
                        headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "7px 5px",
                        }}
                        bodyStyle={{
                            textAlign: "right",
                            fontSize: "10px",
                            padding: "6px",
                            whiteSpace: "nowrap",
                        }}
                        style={{ width: "12%" }}
                    />

                    <Column
                        field="uuid"
                        header={ExportInvoiceDefaultValues.tableHeaderEgress.thUuid}

                        body={(rowData) => (
                            <span
                                title={rowData.uuid || ""}
                                style={{
                                    fontSize: "10px",
                                    overflowWrap: "anywhere",
                                }}
                            >
                                {rowData.uuid || "—"}
                            </span>
                        )}
                        headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "7px 5px",
                        }}
                        bodyStyle={{
                            textAlign: "center",
                            fontSize: "10px",
                            padding: "6px",
                        }}
                        style={{ width: "20%" }}
                    />

                    <Column
                        field="is_paid"
                        header={ExportInvoiceDefaultValues.tableHeaderEgress.thPaid}

                        body={(rowData) => (
                            <span
                                className={`badge ${rowData.is_paid
                                    ? "badge-light-success"
                                    : "badge-light-danger"
                                    }`}
                                style={{
                                    fontSize: "9px",
                                    padding: "5px 7px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {rowData.is_paid
                                    ? "PAGADA"
                                    : "PENDIENTE DE PAGO"}
                            </span>
                        )}
                        headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",

                            padding: "7px 5px",
                        }}
                        bodyStyle={{
                            textAlign: "center",
                            fontSize: "10px",
                            padding: "6px",
                        }}
                        style={{ width: "15%" }}
                    />
                </DataTable>
            </Col>
        </Dialog>
    )
}
